import moment from 'moment'
import { useTranslation } from 'react-i18next'
import {
  Uploader,
  Sheet,
  DetailItem,
  CountySelectFieldDEPRECATED,
} from 'components'
import { FieldBlock, Section } from '@politechdev/blocks-design-system'
import { dateFormat } from 'utils/constants'
import styles from './Upload.module.scss'
import { SHIFT_TYPE } from '../constants'

const Upload = ({ shift, setFiles, setCounty, disabled, county }) => {
  const { t } = useTranslation()

  const endpoint =
    shift.type === SHIFT_TYPE.REGISTRATION
      ? '/system/files/upload?url=true&metadata_generator=voter_registration_form'
      : '/system/files/upload?metadata_generator=petitions'

  return (
    <Sheet>
      <div className="shifts__upload-scans">
        <div className={styles.uploader}>
          <Uploader
            label={t('Scan')}
            onComplete={setFiles}
            autoUpload
            fileTypes={['.pdf']}
            endpoint={endpoint}
            disabled={disabled}
            stringifyData={false}
            fileValidator={file => {
              // eslint-disable-next-line no-useless-escape
              const invalidChars = file.name.match(/[^\w\.]/)

              if (invalidChars) {
                return `Filename contains invalid characters: ${invalidChars.join(
                  ', '
                )}`
              }
            }}
            splitPDFs={shift.type === SHIFT_TYPE.REGISTRATION}
          />
        </div>
        <div className="shifts__upload-scans__meta">
          <Section label={t('Shift info')}>
            <DetailItem label={t('Office of origin')}>
              {shift.turf.name}
            </DetailItem>
            <DetailItem label={t('Canvasser')}>
              {shift.canvasser.full_name}
            </DetailItem>
            <DetailItem label={t('Shift date')}>
              {moment(shift.shift_start).format(dateFormat)}
            </DetailItem>
          </Section>
          {shift.type === SHIFT_TYPE.PETITION ? (
            <FieldBlock>
              <CountySelectFieldDEPRECATED
                required
                county={county}
                label={t('County')}
                onSelect={setCounty}
                state={shift.location.state}
              />
            </FieldBlock>
          ) : null}
        </div>
      </div>
    </Sheet>
  )
}

export default Upload
